import { Action, createReducer, on } from '@ngrx/store';
import { IGovernmentIdDataRequest, IGovernmentIdDataResponse } from '../models/governmentId.model';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';
import { loadGovernmentIdRequest, loadGovernmentIdResponse, loadGovernmentIdFailure } from '../actions/government-id.actions';

export const governmentIdFeatureKey = 'governmentId';

export interface GovernmentIdState {
  govIdRequest: IGovernmentIdDataRequest;
  govIdResponse: IGovernmentIdDataResponse;
  govIdFailure: IGenericError<ErrorResponse>;
}

export const initialState: GovernmentIdState = {
  govIdRequest: undefined,
  govIdResponse: undefined,
  govIdFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(loadGovernmentIdRequest, (state, action) => ({
    ...state,
    govIdRequest: action.request
  })),
  on(loadGovernmentIdResponse, (state, action) => ({
    ...state,
    govIdResponse: action.response
  })),
  on(loadGovernmentIdFailure, (state, action) => ({
    ...state,
    govIdFailure: action.error
  }))
);

export const getgovIdRequest = (state: GovernmentIdState) => state.govIdRequest;
export const getgovIdResponse = (state: GovernmentIdState) => state.govIdResponse;
export const getgovIdFailure = (state: GovernmentIdState) => state.govIdFailure;
